import { z } from "zod";
import { ASSIGNABLE_CLINIC_ROLES } from "@fysaro/domain";
import {
  GENDER_OPTIONS,
  LANGUAGE_CODES,
  validateInternationalId,
  VALIDATION_KEYS,
} from "@fysaro/shared";

export const staffRoleSchema = z.enum(ASSIGNABLE_CLINIC_ROLES, {
  message: VALIDATION_KEYS.STAFF.ROLE,
});

export const assignStaffToClinicSchema = z
  .object({
    clinicId: z.string().uuid(),
    role: staffRoleSchema,
  })
  .strict();

export const createStaffInvitationSchema = z
  .object({
    email: z.string().email(VALIDATION_KEYS.GENERIC.INVALID_EMAIL),
    role: staffRoleSchema,
    language: z.enum(LANGUAGE_CODES),
  })
  .strict();

export const baseStaffSchema = z
  .object({
    // --- CAMPOS COMUNES ---
    name: z.string().min(2, VALIDATION_KEYS.STAFF.NAME_REQUIRED),
    email: z.string().email(VALIDATION_KEYS.GENERIC.INVALID_EMAIL),
    phone: z.string().optional().nullable(),
    role: staffRoleSchema,

    identificationNumber: z
      .string()
      .trim()
      .toUpperCase()
      .or(z.literal(""))
      .transform((val) => (val === "" ? null : val))
      .optional()
      .nullable(),

    // --- CAMPOS OPCIONALES (Base) ---
    title: z.string().max(100).optional().nullable(),
    bio: z.string().max(1000).optional().nullable(),
    imageUrl: z.string().url().optional().nullable(),

    // --- Dirección Base (UserProfile) ---
    address: z.string().optional().nullable(),
    street: z.string().optional().nullable(),
    housenumber: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    zipCode: z.string().optional().nullable(),
    country: z.string().default("España"),
    countryCode: z.string().default("ES"),
    latitude: z.number().optional().nullable(),
    longitude: z.number().optional().nullable(),
    language: z.string().optional().nullable(),
    theme: z.string().optional().nullable(),

    // --- CAMPOS ESPECÍFICOS DE PROFESIONAL ---
    specialtyId: z.string().uuid().optional().nullable(),
    licenseNumber: z.string().optional().nullable(),
    color: z
      .string()
      .regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
      .default("#3b82f6"),

    gender: z.enum(GENDER_OPTIONS).optional().nullable(),
    birthDate: z.string().optional().nullable(),
    internalNotes: z.string().optional().nullable(),
    tags: z.array(z.string()).optional().default([]),
    forceUpdate: z.boolean().optional().default(true),
  })
  .strict();

export const createStaffSchema = baseStaffSchema.superRefine(
  validateInternationalId,
);

export const updateStaffSchema = baseStaffSchema
  .partial()
  .superRefine(validateInternationalId)
  .strict();

export const updateStaffImageSchema = z.object({
  imageUrl: z.string().url().nullable(),
});

export const inviteStaffSchema = z
  .object({
    name: z.string().min(2, VALIDATION_KEYS.STAFF.NAME_REQUIRED),
    phone: z.string().optional().nullable(),
    email: z.string().email(VALIDATION_KEYS.GENERIC.INVALID_EMAIL),
    specialtyId: z.string().uuid().optional().nullable(),
    role: staffRoleSchema,
    identificationNumber: z
      .string()
      .trim()
      .toUpperCase()
      .or(z.literal(""))
      .transform((val) => (val === "" ? null : val))
      .optional()
      .nullable(),
    countryCode: z.string().default("ES"),
    password: z.string().min(6),
  })
  .superRefine(validateInternationalId);
